import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { StoreService } from "../services/store.service";
import { ActiveKYCMode } from "src/app/auth/auth.interface";
import { AuthService } from "src/app/auth/auth.service";

@Injectable()
export class UnAuthGuard {
    constructor(
        private router: Router,
        private storeService: StoreService,
        private authService: AuthService
    ) {}
    canActivate(): boolean {
        let mobileToken = this.storeService.get("m-token");
        let token = this.storeService.get("token");

        if (token && token !== "null" && token !== "undefined") {
            this.router.navigate(["/loan/timeline"]);
        } else if (mobileToken && mobileToken !== "null" && mobileToken !== "undefined") {
            let getAuthDetails: any = this.storeService.get("unAuthDetails");
            getAuthDetails = JSON.parse(getAuthDetails || "{}");

            if (getAuthDetails && getAuthDetails?.activeKYCMode == ActiveKYCMode.NEW_MODE) {
                this.authService.validation();
            } else {
                this.router.navigate(["/auth/register"]);
            }
        }

        return true;
    }
}
